export default __webpack_public_path__ + "static/media/pølse.37efa6b7.png";